export default "__VITE_ASSET__DIVGPiQV__"